import { Box, styled } from '@mui/material';

import { SizingMultiplier } from '../../sizing-multiplier.constant';

type PaperProps = {
  outlined?: boolean;
  square?: boolean;
  elevation?: number;
  p?: number;
};

export const Paper = styled(Box)<PaperProps>(({ theme, outlined = false, square = false, elevation = 0, p }) => ({
  background: theme.palette.background.paper,
  padding: p ?? theme.spacing(SizingMultiplier.md),
  borderRadius: square ? 0 : 16,
  border: outlined ? `1px solid ${theme.palette.divider}` : 'none',
  boxShadow: elevation ? theme.shadows[elevation] : 'none',
}));
